import { Load } from './classes/Load';
import { Scroll } from './classes/Scroll';
import { Color } from './classes/Color';
import { SectionLinks } from './classes/SectionLinks';
import { PlaylistProximity } from './classes/PlaylistProximity';
import { CardSlider } from './classes/CardSlider';
import { ConnectedLines } from './classes/ConnectedLines';
import { CSS_CLASS } from './config';
import { gsap } from 'gsap';
import { SplitText } from 'gsap/SplitText';
import globals from './globals';
import registerComponents from './registerComponents';

/*
 * Initialize the app
 */
async function init() {
  /* Initialize GSAP */
  gsap.registerPlugin(SplitText);

  /* Register components */
  registerComponents();

  /* Initialize global variables */
  globals();

  /* Initialize the Scroll class */
  Scroll.init();

  /* Initialize the Color class */
  Color.init();

  /* Initialize the SectionLinks class */
  SectionLinks.init();

  /* Initialize the PlaylistProximity class */
  PlaylistProximity.init();

  /* Initialize the CardSlider class */
  CardSlider.init();

  /* Initialize the ConnectedLines class */
  ConnectedLines.init();

  /* Initialize the Load class */
  const load = new Load();
  load.init();

  /* Set default classes */
  document.documentElement.classList.add(CSS_CLASS.FIRST_LOADED, CSS_CLASS.LOADED, CSS_CLASS.READY);

  document.documentElement.classList.remove(CSS_CLASS.LOADING);

  /**
   * Debug focus
   */
  // document.addEventListener(
  //   'focusin',
  //   function () {
  //     console.log('focused: ', document.activeElement);
  //   },
  //   true
  // );

  /**
   * Eagerly load the following fonts.
   */
  // if (isFontLoadingAPIAvailable) {
  //   loadFonts(FONT.EAGER, ENV.IS_DEV).then(eagerFonts => {
  //     document.documentElement.classList.add(CSS_CLASS.FONTS_LOADED);

  /**
   * Debug fonts loading
   */
  /* if (ENV.IS_DEV) {
                console.group('Eager fonts loaded!', eagerFonts.length, '/', document.fonts.size);
                console.group('State of eager fonts:');
                eagerFonts.forEach(font => console.log(font.family, font.style, font.weight, font.status));
                console.groupEnd();
                console.group('State of all fonts:');
                document.fonts.forEach(font => console.log(font.family, font.style, font.weight, font.status));
                console.groupEnd();
            } */
  // });
  // }
}

/*
 * Execute the app
 */
window.addEventListener('load', () => {
  init();
});
